import { render, staticRenderFns } from "./StatementChart.vue?vue&type=template&id=788774e8&scoped=true&"
import script from "./StatementChart.vue?vue&type=script&lang=ts&"
export * from "./StatementChart.vue?vue&type=script&lang=ts&"
import style0 from "./StatementChart.vue?vue&type=style&index=0&id=788774e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788774e8",
  null
  
)

export default component.exports